import React from 'react';

type Props = {
  guestPicture: string;
  guestName: string;
  tierName: string;
  bundleName?: string;
};

const TicketHolder = ({
  guestPicture,
  guestName,
  tierName,
  bundleName
}: Props) => (
  <div className="flex-1 flex-row flex">
    <img
      className="w-11 h-11 rounded-full border-1 border-solid border-neutral-700"
      src={guestPicture || '/img/user/default.png'}
    />
    <div className="ml-2">
      <div className="font-bold text-base">{guestName}</div>
      {bundleName ? (
        <div className="font-normal">
          <span className="font-semibold">Bundle:</span> {bundleName}
        </div>
      ) : (
        <div className="font-normal">
          <span className="font-semibold">Ticket:</span> {tierName}
        </div>
      )}
    </div>
  </div>
);

export default TicketHolder;
